import React from "react";
import { connect } from "react-redux";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/Search";
import MoreIcon from "@material-ui/icons/MoreVert";
import DescriptionIcon from "@material-ui/icons/Description";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import ScheduleIcon from "@material-ui/icons/Schedule";
import GavelIcon from "@material-ui/icons/Gavel";
import MapIcon from "@material-ui/icons/Map";
import HelpIcon from "@material-ui/icons/Help";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import RoomIcon from "@material-ui/icons/Room";
import ListAltIcon from '@material-ui/icons/ListAlt';
import InfoIcon from '@material-ui/icons/Info';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { withTranslation, Trans } from "react-i18next";
import Popover from '@material-ui/core/Popover';
import Button from '@material-ui/core/Button';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import InboxIcon from '@material-ui/icons/Inbox';
import DraftsIcon from '@material-ui/icons/Drafts';
import Grid from '@material-ui/core/Grid';
import imgUrl from '../../assets/images/imageUrl.js';
import SettingsIcon from '@material-ui/icons/Settings';
import swal from "sweetalert";


import {
  Link,
  NavLink,
  useHistory,
  withRouter,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";

import {
  setSelectedComponentObject,
  resetSelectedCompnentObject,
  setBottomNavComponentObject,
  partialSetSelectedComponentObject,
  setcomponentbgcolor
} from "../../redux/actions/appActions";

var count = 0
var temp1popupmenu = []
class BottomAppBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      checked: false,
      isSettingSelected: false,
      anchorEl: null,
      // menuiconobj: {
      //   1: { id: 1, backgrond: "greenbg", icon: <GavelIcon /> },
      //   2: { id: 2, backgrond: "redbg", icon: <RoomIcon /> },
      //   3: { id: 3, backgrond: "bluebg", icon: <DescriptionIcon /> },
      //   4: { id: 4, backgrond: "yellowbg", icon: <QuestionAnswerIcon /> },
      //   5: { id: 5, backgrond: "blackbg", icon: <QuestionAnswerIcon /> },
      //   6: { id: 6, backgrond: "greenbg", icon: <ScheduleIcon /> },
      //   7: { id: 7, backgrond: "brownbg", icon: <ScheduleIcon /> },
      //   10: { id: 10, backgrond: "orangebg", icon: <ListAltIcon /> },
      //   28: { id: 28, backgrond: "yellowbg", icon: <HelpIcon /> },
      //   51: { id: 51, backgrond: "bluebg", icon: <DescriptionIcon /> },
      // },
      menuList:
        JSON.parse(localStorage.getItem("menuList")) != null
          ? JSON.parse(localStorage.getItem("menuList"))
          : [],
    };


  }

  componentDidMount() {
    if (this.props.location.pathname == "/layout/settings") {
      this.setState({
        isSettingSelected: true,
      })
    }
  }

  handleClickSetting(menuobj) {
    this.setState({
      isSettingSelected: true,
    })
    localStorage.setItem('componentbgcolor', menuobj.state.componentbgcolor)
    this.props.setcomponentbgcolor(menuobj.state.componentbgcolor)
    this.props.setBottomNavComponentObject({});
    this.props.partialSetSelectedComponentObject({});
    this.handlpopupClose()
    this.props.history.replace({
      pathname: menuobj.pathname,
      state: {},
    });
  }

  handleClick(menuobj) {
    const { t } = this.props;
    var self = this;
    console.log("footer menuobj::", menuobj);
    //setOpen(!open);
    if (window.location.hash != `#${menuobj.pathname}`) {
      this.setState({
        isSettingSelected: false
      })

      if(window.cordova && menuobj.pathname == "/layout/nearme"){
        // window.CheckGPS.check(function(){
        //   //GPS is enabled!
        //   try{
        //     localStorage.setItem('componentbgcolor', menuobj.state.componentbgcolor)
        //     self.props.setcomponentbgcolor(menuobj.state.componentbgcolor)
        //     self.props.setBottomNavComponentObject(menuobj.state);
        //     self.props.partialSetSelectedComponentObject(menuobj.state);
        //     self.handlpopupClose()
        //     self.props.history.replace({
        //       pathname: menuobj.pathname,
        //       state: menuobj.state,
        //     });
        //   } catch(err) {
        //     console.log('gps:' err)
        //   }
        // },function(){
        //   //GPS is disabled!
        //   swal({
        //     text: t("Please turn on your location/GPS"),
        //     icon: "warning",
        //     button: t("ok"),
        //   })
        // });

        localStorage.setItem('componentbgcolor', menuobj.state.componentbgcolor)
        this.props.setcomponentbgcolor(menuobj.state.componentbgcolor)
        this.props.setBottomNavComponentObject(menuobj.state);
        this.props.partialSetSelectedComponentObject(menuobj.state);
        this.handlpopupClose()
        this.props.history.replace({
          pathname: menuobj.pathname,
          state: menuobj.state,
        });
      }else{
        // this.props.setSelectedComponentObject(menuobj.state);
        localStorage.setItem('componentbgcolor', menuobj.state.componentbgcolor)
        this.props.setcomponentbgcolor(menuobj.state.componentbgcolor)
        this.props.setBottomNavComponentObject(menuobj.state);
        this.props.partialSetSelectedComponentObject(menuobj.state);
        this.handlpopupClose()
        this.props.history.replace({
          pathname: menuobj.pathname,
          state: menuobj.state,
        });
      }
    }
  }

  mountMenu(menu, menuiconobj) {
    const { templateID } = this.props;
    if (templateID == 1) {
      return this.tempalte1Menu(menu, menuiconobj)
    } if (templateID == 2) {
      return this.tempalte2Menu(menu, menuiconobj)
    }
  }


  tempalte2Menu(menu, menuiconobj) {
    let menuContent = [];
    //if (menuiconobj[menu.id] != undefined) {
    if (menu.layout != null) {
      // var spliurtl = menu.icon.split("://")
      // let myUrl = spliurtl.length > 1 ? "https://" + spliurtl[1] : "https://" + spliurtl[0];
      let menuicon = this.getMenuIcon(menu)
      menuContent.push(
        <Link
          className={
            this.props.selectedBottomComponentObj.id == menu.componentId ? "active" : ""
          }
          key={menu.id}
          name={menu.name}
          onClick={() =>
            this.handleClick({
              pathname: `/layout/${menu.path}`,
              state: {
                name: menu.name,
                id: menu.componentId,
                componentbgcolor: menu.layout.componentbgcolor,
              },
            })
          }
        >
          <IconButton color="inherit">
            {
             menuicon
            }
          </IconButton>
        </Link>
      );
    }
    return menuContent;
  }

  tempalte1Menu(menu, menuiconobj) {
    const { t } = this.props;
    let menuContent = [];
    if (count < 3 && menu.layout != null) {
      // var spliurtl = menu.icon.split("://")
      // let myUrl = spliurtl.length > 1 ? "https://" + spliurtl[1] : "https://" + spliurtl[0];
      let menuicon = this.getMenuIcon(menu)
      let name = menu.label;
      menuContent.push(
        <Grid item xs={4} >
          <a
            className={
              this.props.selectedBottomComponentObj.id == menu.componentId ? "active" : ""
            }
            key={menu.id}
            name={menu.name}
            onClick={() =>
              this.handleClick({
                pathname: `/layout/${menu.path}`,
                state: {
                  name: menu.name,
                  id: menu.componentId,
                  componentbgcolor: menu.layout.componentbgcolor,
                },
              })
            }
          >
            <p className="zero vertical-align-center">
             {menuicon}
            </p>
            {/* <p className="zero vertical-align-center">{t(name)}</p> */}
          </a>
        </Grid>
      );
      count++;
    } else if (menu.layout != null) {
      // var spliurtl = menu.icon.split("://")
      // let myUrl = spliurtl.length > 1 ? "https://" + spliurtl[1] : "https://" + spliurtl[0];
      let menuicon = this.getMenuIcon(menu)
      let name = menu.label;
      temp1popupmenu.push(
        <a
          className={
            this.props.selectedBottomComponentObj.id == menu.componentId ? "active" : ""
          }
          key={menu.id}
          name={menu.name}
          onClick={() =>
            this.handleClick({
              pathname: `/layout/${menu.path}`,
              state: {
                name: menu.name,
                id: menu.componentId,
                componentbgcolor: menu.layout.componentbgcolor,
              },
            })
          }
        >
          <ListItem button >
            <ListItemIcon>  {menuicon}</ListItemIcon>
            <Trans> <ListItemText primary={t(name)} /></Trans>
          </ListItem>
        </a>
      );
      count++;
    }
    return menuContent;
  }

  getMenuIcon(menu) {
    if(menu.className){
      return <i className={"demo-icon "+ menu.className}></i>
    } else if (menu.icon != "") {
      let myUrl = this.getHttpsUrl(menu.icon)
      return <img className="img-fluid" src={myUrl} />
    } else {
      return  <InfoIcon />
    }
  }

  getHttpsUrl(iconurl) {
    var spliurtl = iconurl.split("://")
    let myUrl = spliurtl.length > 1 ? "https://" + spliurtl[1] : "https://" + spliurtl[0];
    return myUrl;
  }


  handlpopupClick = (event) => {
    this.setState({ anchorEl: event.currentTarget })
  };

  handlpopupClose = () => {
    this.setState({ anchorEl: null })
  };



  render() {
    const { t } = this.props;
    let list = this.state.menuList;
    let menuiconobj = this.state.menuiconobj;
    var menuContent = [];
    const open = Boolean(this.state.anchorEl);
    const id = open ? 'simple-popover' : undefined;
    count = 0;
    temp1popupmenu = []
    list.map((menu, i) => {
      if (menu.visible && menu.isactive && menu.path != "settings") {
        menuContent.push(this.mountMenu(menu, menuiconobj));
      } else if (menu.path == "information") {
        menu.childs.map((submenu) => {
          if (submenu.visible && submenu.isactive) {
            menuContent.push(this.mountMenu(submenu, menuiconobj));
          }
        });
      }
    });
    const { templateID } = this.props;
    let colorStyles = templateID == 2 ? { background: this.props.componentbgcolor } : {};
    return (
      <React.Fragment>
        <AppBar position="fixed" color="#fff" className={templateID == 2 ? 'bottom-appbar' : 'botnavmainholder'} style={colorStyles}>
          <Toolbar className={templateID == 2 ? 'zero bottom-toolbar' : 'bottom-navigation-menu'} style={{ overflowX: 'scroll' }}>
            {
              templateID == 1 ? (
                <Grid container spacing={3} className="gridcontainer botnavinnerholder">{menuContent}</Grid>
              ) : (menuContent)
            }

            {
              templateID == 2 ? (
                <Link className={this.state.isSettingSelected ? "active" : ""}
                  onClick={() =>
                    this.handleClickSetting({
                      pathname: `/layout/settings`,
                      state: {
                        name: "settings",
                        componentbgcolor: "#009596",
                      },
                    })
                  }
                >
                  <IconButton edge="end" color="inherit">
                    <MenuIcon />
                  </IconButton>
                </Link>) : (
                <div>
                  <Button
                    aria-describedby={id}
                    className="text-capitalize moremenu" variant="contained"
                    onClick={this.handlpopupClick}>
                    <MoreVertIcon />
                   
                  </Button>
                  <Popover
                    id={id}
                    open={open}
                    anchorEl={this.state.anchorEl}
                    onClose={this.handlpopupClose}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                    className="bottonnavPopup"
                  >
                    <Typography>
                      {temp1popupmenu}
                      <Link className={this.state.isSettingSelected ? "active" : ""}
                        onClick={() =>
                          this.handleClickSetting({
                            pathname: `/layout/settings`,
                            state: {
                              name: "settings",
                              componentbgcolor: "#009596",
                            },
                          })
                        }
                      >
                        <ListItem button >
                          <ListItemIcon> <SettingsIcon style={{ fontSize: 40 }}></SettingsIcon></ListItemIcon>
                          <Trans> <ListItemText primary={t('Settings')} /></Trans>
                        </ListItem>
                      </Link>
                    </Typography>
                  </Popover>
                </div>
              )
            }
          </Toolbar>
        </AppBar>
      </React.Fragment>
    );
  }
}

// export default BottomAppBar;

const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    selectedComponentObj: storeState.componentObj,
    selectedBottomComponentObj: storeState.bottomComponentObj,
    componentbgcolor: storeState.componentbgcolor
  };
};

const TranslationBottomAppBar = withTranslation()(BottomAppBar);
const FinalBottomAppBar = withRouter(TranslationBottomAppBar);

export default connect(mapStateToProps, {
  setSelectedComponentObject,
  resetSelectedCompnentObject,
  setBottomNavComponentObject,
  partialSetSelectedComponentObject,
  setcomponentbgcolor
})(FinalBottomAppBar);
